import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const UnpublishConfirmModal = ({
  onClose,
  unpublish
}) => {
  return /*#__PURE__*/_jsx(ConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "unpublishModal.message"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "unpublishModal.description"
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editor.publishing.unpublish"
    }),
    onConfirm: () => {
      unpublish();
      onClose();
    },
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "unpublishModal.cancel"
    }),
    onReject: onClose,
    size: "auto"
  });
};
export default UnpublishConfirmModal;